import { recipeHue } from '@recipes/domain';
import { cn } from '@recipes/ui';
import { HUE_SOLID, HUE_SURFACE } from './hue-classes';

/**
 * A recipe without a photo (docs/partial/appearance-and-themes-spec.md 6.4): its hue – by meal
 * type, else category, else title – with a few paper dots and the first letter, instead of a
 * grey box. The same recipe looks the same wherever it appears. Decorative: the title is next
 * to it everywhere.
 */
export function RecipePlaceholder({
  recipe,
  className,
  small,
}: {
  recipe: {
    title: string;
    mealType?: string | null;
    categories?: Array<{ id: string; slug?: string }>;
  };
  className?: string;
  /** A thumbnail in a list row: the letter only. */
  small?: boolean;
}) {
  const hue = recipeHue(recipe);
  const letter = [...recipe.title.trim()][0]?.toLocaleUpperCase() ?? '';
  return (
    <div
      aria-hidden
      data-testid="recipe-placeholder"
      data-hue={hue}
      className={cn(
        'relative flex items-center justify-center overflow-hidden font-bold',
        HUE_SURFACE[hue],
        small ? 'text-base' : 'text-5xl',
        className,
      )}
    >
      {!small && (
        <>
          <span
            className={cn(
              'absolute -left-6 -top-6 size-24 rounded-full opacity-25',
              HUE_SOLID[hue],
            )}
          />
          <span
            className={cn(
              'absolute -bottom-8 right-6 size-28 rounded-full opacity-15',
              HUE_SOLID[hue],
            )}
          />
          <span
            className={cn('absolute right-4 top-4 size-5 rounded-full opacity-40', HUE_SOLID[hue])}
          />
        </>
      )}
      <span className="relative">{letter}</span>
    </div>
  );
}
